<template>
    <div class="groupList">
        <div class="group-item" v-for="(item,index) in groupList" :key="index" @click="seeDetail(item)">
            <img :src="item.userFaceUrl" alt="">
            <p class="name">{{item.userName}}</p>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            chatId:this.$route.query.chatId,
            groupList:[]
        }
    },
    created () {
        this.getGroupData()
    },
    methods: {
        getGroupData(){
            this.$imapiAxio.post('/im/chat-users/list',{chatId:this.chatId}).then(result => {
                this.groupList = result.data;
            })
        },
        seeDetail(item){
            if(item.userRegRole == 100002){
                this.$router.push(`/staff/detail/${item.userId}`)
            }
        }

        
    }
}
</script>

<style lang="less" scoped>
.groupList{
    height: 100%;
    overflow: auto;
    background: #F5F6FA;
    padding: 0.3rem;
    box-sizing: border-box;
    .group-item{
        width: 20%;
        float: left;
        padding: 0 0.1rem;
        margin-top: 0.8rem;
        box-sizing: border-box;
        img{
            width: 2rem;
            height: 2rem;
            display: block;
            border-radius: 50%;
            margin: 0 auto;
        }
        .name{
            width: 100%;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 0.2rem;
            white-space: nowrap;
            font-size: 0.52rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
        }
    }

}
</style>